import { render, staticRenderFns } from "./BrandIndex.vue?vue&type=template&id=34f6c33c&"
import script from "./BrandIndex.vue?vue&type=script&lang=js&"
export * from "./BrandIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports